import { render } from "./FileDownload.vue?vue&type=template&id=fc5d94a6&scoped=true"
const script = {}

import "./FileDownload.vue?vue&type=style&index=0&id=fc5d94a6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc5d94a6"]])

export default __exports__